import DataSourceFilter from './adapter';

export default DataSourceFilter;
